export const strokeWidth = {
  width1: '1px',
  width2: '2px',
  width4: '4px',
};
